<template>
  <v-dialog v-model="dialog" width="500" persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-list-item v-bind="attrs" v-on="on">
        <v-list-item-title>Update Payment Method</v-list-item-title>
      </v-list-item>
    </template>

    <v-card class="rounded-xl">
      <v-card-title class="headline" primary-title>
        Update Payment Info
      </v-card-title>

      <v-card-text>
        <p>
          Unless there is a default card assigned to this location, all
          charges will be made on the default Organization card
        </p>
        <v-row align="center">
          <v-col>Cards</v-col>

          <v-col class="shrink">
            <AddCard @reloadCard="loadCards" />
          </v-col>
        </v-row>

        <v-card class="mt-4" outlined v-if="cards">
          <v-list two-line class="cardList">
            <v-list-item v-for="(card, index) in cards" :key="index">
              <v-list-item-content>
                <v-list-item-title>
                  {{ card.brand }} ●●●● {{ card.last4 }}
                </v-list-item-title>
                <v-list-item-subtitle>Expires {{ card.exp_month }}/{{ card.exp_year }}
                  <v-chip label small color="blue lighten-4" text-color="blue darken-4"
                    v-if="customer && card.id === defaultCardId">Selected</v-chip></v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-action>
                <v-menu bottom left offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn v-bind="attrs" v-on="on" icon>
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>

                  <v-list class="menu-button" width="100%">
                    <v-list-item @click="setDefaultCard(card)" v-if="customer && card.id !== defaultCardId">
                      <v-list-item-title>Select This One</v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="deleteCard(card)">
                      <v-list-item-title>Delete</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-card>

        <v-card outlined class="mt-2 cardList" v-else>
          <v-skeleton-loader type="list-item-three-line"></v-skeleton-loader>
        </v-card>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="close"> Close </v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="isLoading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text class="pa-5">
          Please Stand By
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>
<script>
import settingsService from "@/modules/BackOffice/service.js";
import locationService from "@/modules/Location/service.js";
import AddCard from "@/modules/Location/components/AddCard.vue";

export default {
  name: "billing-update-payment",
  props: ["locationId", "subscription", "customer", "defaultCardId"],
  components: {
    AddCard,
  },
  data() {
    return {
      dialog: false,
      isLoading: false,
      cards: null,
    };
  },
  methods: {
    close() {
      this.cards = []
      this.dialog = false
    },
    loadCards() {
      console.log('v-if="dialog"')
      // this.$emit("update");
      return settingsService.Billing.getCards()
        .then((response) => {
          console.log('loading card', response)
          // Data comes straight from stripe and they model their data inside data
          this.cards = response.data.data;
          // if (this.cards.length === 1)
          //   this.$emit("updateDefault", this.cards[0]);
          // this.$Progress.finish();
        })
        .catch((error) => {
          console.log(error);
          // this.$Progress.error();
        });
    },
    // getCustomer() {
    //   return settingsService.Billing.getCustomer()
    //     .then((response) => {
    //       console.log("response.data", response.data);
    //       // Data comes straight from stripe and they model their data inside data
    //       this.customer = response.data;

    //       if (this.customer && this.customer.default_source) {
    //         this.defaultCardId = this.customer.default_source;
    //       }

    //       if (this.subscription && this.subscription.default_source) {
    //         this.defaultCardId = this.subscription.default_source;
    //       }
    //     })
    //     .catch((error) => {
    //       console.log(error);
    //       this.$Progress.error();
    //     });
    // },
    setDefaultCard(card) {
      this.isLoading = true;
      locationService.Billing.setDefaultCard(this.locationId, {
        source: card.id,
      })
        .then(() => {
          this.isLoading = false;
          this.loadCards();
          // this.getCustomer();
          this.$emit("update");
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
        });
    },
    deleteCard(card) {
      console.log("delete", card);
      return this.$swal
        .fire({
          title: "Are you sure?",
          text: `You want to remove card ending with ${card.last4}`,
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes",
          cancelButtonText: "No",
        })
        .then((result) => {
          if (result.isConfirmed) {
            settingsService.Billing.deleteCard(card.id)
              .then(() => {
                this.$toast.success("Card was removed!", { timeout: 2000 });
                this.loadCards();
              })
              .catch((error) => {
                this.$toast.error(error.data ? error.data.message : "Error", {
                  timeout: 2000,
                });
                console.log(error);
              });
            // employeeService.delete(employee.id).then((response) => {
            //   if (response.data) {
            //     this.$toast.success("Employee has been deleted", {
            //       timeout: 2000,
            //     });

            //     this.getAll();
            //   }
            // });
          }
        })
        .catch((error) => {
          this.$toast.error(error.data ? error.data.message : "Error", {
            timeout: 2000,
          });
        });
    },
  },
  watch: {
    dialog(val) {
      if (val) {
        console.log('customer', this.customer)
        this.isLoading = true;
        this.loadCards().then(() => {
          this.isLoading = false;
        });
        // this.getCustomer();
      }
    },
  },
};
</script>

<style scoped>
.cardList {
  max-height: 250px;
  overflow: auto;
}
</style>
